import EntityMapper from '../EntityMapper';

import PrefMapper, {PrefData} from '../PrefMapper';

import GenderMapper, {
  GenderData,
} from '../../../value_objects/mappers/GenderMapper';

import UserProfile from '../../../../domain/entities/consumer/UserProfile';

export interface UserProfileData {
  id: number;
  description: string;
  has_image: boolean;
  original_image_url: string;
  gender: GenderData | null;
  birthday: string | null;
  pref: PrefData | null;
}

export default class UserProfileMapper
  implements EntityMapper<UserProfileData, UserProfile>
{
  private prefMapper = new PrefMapper();
  private genderMapper = new GenderMapper();

  public map(obj: UserProfileData): UserProfile {
    return new UserProfile(
      obj.id,
      obj.description,
      obj.has_image,
      obj.original_image_url,
      obj.gender ? this.genderMapper.map(obj.gender) : null,
      obj.birthday ? new Date(obj.birthday) : null,
      obj.pref ? this.prefMapper.map(obj.pref) : null,
    );
  }
}
